import { FC, useEffect } from "react";
import { Router } from "react-router-dom";
import MainRoute from "src/Main/Nav/MainRoute";

import Toast from "./Shared/Components/Toast";

import ToastComponent from "./Shared/Components/Toast/ToastComponent";
import ToastProvider from "./Shared/Components/Toast/ToastProvider";

interface AppProps {
  history: History;
};

const App: FC<AppProps> = ({ history }) => {
  useEffect(() => {
    const disablePinchZoom = (e: any) => {
      if (e.touches.length > 1) {
        e.preventDefault();
      }
    };
    document.addEventListener("touchmove", disablePinchZoom, {
      passive: false,
    });

    return () => {
      document.removeEventListener("touchmove", disablePinchZoom);
    };
  }, []);

  return (
    <>
      <ToastProvider>
        <Router history={history}>
          <MainRoute />
        </Router>
      </ToastProvider>
    </>
  );
}

export default App;
